<span *ngIf="diagnosticCenterAddress !=null && diagnosticCenterAddress != ''">{{diagnosticCenterAddress}}</span>
<span *ngIf="diagnosticCenterAddress == ''">N/A</span>